"use strict";

var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step3;
    try {
      var _loop = function _loop() {
        var key = _step3.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  HydrateAtoms: function HydrateAtoms() {
    return _HydrateAtoms;
  },
  atomWithFn: function atomWithFn() {
    return _atomWithFn;
  },
  createAtomProvider: function createAtomProvider() {
    return _createAtomProvider;
  },
  createAtomStore: function createAtomStore() {
    return _createAtomStore;
  },
  useAtomStore: function useAtomStore() {
    return _useAtomStore;
  },
  useHydrateStore: function useHydrateStore() {
    return _useHydrateStore;
  },
  useSyncStore: function useSyncStore() {
    return _useSyncStore;
  }
});
module.exports = __toCommonJS(src_exports);

// src/atomWithFn.ts
var import_jotai = require("jotai");
var wrapFn = function wrapFn(fnOrValue) {
  return typeof fnOrValue === "function" ? {
    __fn: fnOrValue
  } : fnOrValue;
};
var unwrapFn = function unwrapFn(wrappedFnOrValue) {
  return wrappedFnOrValue && typeof wrappedFnOrValue === "object" && "__fn" in wrappedFnOrValue ? wrappedFnOrValue.__fn : wrappedFnOrValue;
};
var _atomWithFn = function _atomWithFn(initialValue) {
  var baseAtom = (0, import_jotai.atom)(wrapFn(initialValue));
  return (0, import_jotai.atom)(function (get) {
    return unwrapFn(get(baseAtom));
  }, function (_get, set, value) {
    return set(baseAtom, wrapFn(value));
  });
};

// src/createAtomProvider.tsx
var import_react2 = __toESM(require("react"));
var import_vanilla = require("jotai/vanilla");

// src/useHydrateStore.ts
var import_react = __toESM(require("react"));
var import_jotai2 = require("jotai");
var import_utils = require("jotai/utils");
var _useHydrateStore = function _useHydrateStore(atoms, initialValues) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = [];
  for (var _i = 0, _Object$keys = Object.keys(atoms); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var initialValue = initialValues[key];
    if (initialValue !== void 0) {
      values.push([atoms[key], initialValue]);
    }
  }
  (0, import_utils.useHydrateAtoms)(values, options);
};
var _useSyncStore = function _useSyncStore(atoms, values) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    store = _ref.store;
  var _loop2 = function _loop2() {
    var key = _Object$keys2[_i2];
    var value = values[key];
    var atom2 = atoms[key];
    var set = (0, import_jotai2.useSetAtom)(atom2, {
      store: store
    });
    import_react.default.useEffect(function () {
      if (value !== void 0 && value !== null) {
        set(value);
      }
    }, [set, value]);
  };
  for (var _i2 = 0, _Object$keys2 = Object.keys(atoms); _i2 < _Object$keys2.length; _i2++) {
    _loop2();
  }
};

// src/createAtomProvider.tsx
var getFullyQualifiedScope = function getFullyQualifiedScope(storeName, scope) {
  return "".concat(storeName, ":").concat(scope);
};
var PROVIDER_SCOPE = "provider";
var AtomStoreContext = import_react2.default.createContext(/* @__PURE__ */new Map());
var _useAtomStore = function _useAtomStore(storeName) {
  var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PROVIDER_SCOPE;
  var warnIfUndefined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var _a;
  var storeContext = import_react2.default.useContext(AtomStoreContext);
  var store = (_a = storeContext.get(getFullyQualifiedScope(storeName, scope))) != null ? _a : storeContext.get(getFullyQualifiedScope(storeName, PROVIDER_SCOPE));
  if (!store && warnIfUndefined) {
    console.warn("Tried to access jotai store '".concat(storeName, "' outside of a matching provider."));
  }
  return store;
};
var _HydrateAtoms = function _HydrateAtoms(_a) {
  var _b = _a,
    initialValues = _b.initialValues,
    children = _b.children,
    store = _b.store,
    atoms = _b.atoms,
    props = __objRest(_b, ["initialValues", "children", "store", "atoms"]);
  _useHydrateStore(atoms, __spreadValues(__spreadValues({}, initialValues), props), {
    store: store
  });
  _useSyncStore(atoms, props, {
    store: store
  });
  return /* @__PURE__ */import_react2.default.createElement(import_react2.default.Fragment, null, children);
};
var _createAtomProvider = function _createAtomProvider(storeScope, atoms) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var Effect = options.effect;
  return function (_a) {
    var _b = _a,
      store = _b.store,
      scope = _b.scope,
      children = _b.children,
      resetKey = _b.resetKey,
      props = __objRest(_b, ["store", "scope", "children", "resetKey"]);
    var _import_react2$defaul = import_react2.default.useState((0, import_vanilla.createStore)()),
      _import_react2$defaul2 = _slicedToArray(_import_react2$defaul, 2),
      storeState = _import_react2$defaul2[0],
      setStoreState = _import_react2$defaul2[1];
    import_react2.default.useEffect(function () {
      if (resetKey) {
        setStoreState((0, import_vanilla.createStore)());
      }
    }, [resetKey]);
    var previousStoreContext = import_react2.default.useContext(AtomStoreContext);
    var storeContext = import_react2.default.useMemo(function () {
      var newStoreContext = new Map(previousStoreContext);
      if (scope) {
        newStoreContext.set(getFullyQualifiedScope(storeScope, scope), storeState);
      }
      newStoreContext.set(getFullyQualifiedScope(storeScope, PROVIDER_SCOPE), storeState);
      return newStoreContext;
    }, [previousStoreContext, scope, storeState]);
    return /* @__PURE__ */import_react2.default.createElement(AtomStoreContext.Provider, {
      value: storeContext
    }, /* @__PURE__ */import_react2.default.createElement(_HydrateAtoms, __spreadValues({
      store: storeState,
      atoms: atoms
    }, props), !!Effect && /* @__PURE__ */import_react2.default.createElement(Effect, null), children));
  };
};

// src/createAtomStore.ts
var import_jotai3 = require("jotai");
var capitalizeFirstLetter = function capitalizeFirstLetter() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return str.length > 0 ? str[0].toUpperCase() + str.slice(1) : "";
};
var getProviderIndex = function getProviderIndex() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return "".concat(capitalizeFirstLetter(name), "Provider");
};
var getStoreIndex = function getStoreIndex() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return name.length > 0 ? "".concat(name, "Store") : "store";
};
var getUseStoreIndex = function getUseStoreIndex() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return "use".concat(capitalizeFirstLetter(name), "Store");
};
var isAtom = function isAtom(possibleAtom) {
  return !!possibleAtom && typeof possibleAtom === "object" && "read" in possibleAtom && typeof possibleAtom.read === "function";
};
var withDefaultOptions = function withDefaultOptions(fnRecord, defaultOptions) {
  return Object.fromEntries(Object.entries(fnRecord).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      fn = _ref3[1];
    return [key, function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return fn(__spreadValues(__spreadValues({}, defaultOptions), options));
    }];
  }));
};
var convertScopeShorthand = function convertScopeShorthand() {
  var optionsOrScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return typeof optionsOrScope === "string" ? {
    scope: optionsOrScope
  } : optionsOrScope;
};
var _createAtomStore = function _createAtomStore(initialState, _ref4) {
  var name = _ref4.name,
    delayRoot = _ref4.delay,
    effect = _ref4.effect,
    extend = _ref4.extend;
  var providerIndex = getProviderIndex(name);
  var useStoreIndex = getUseStoreIndex(name);
  var storeIndex = getStoreIndex(name);
  var atomsWithoutExtend = {};
  var writableAtomsWithoutExtend = {};
  var atomIsWritable = {};
  for (var _i3 = 0, _Object$entries = Object.entries(initialState); _i3 < _Object$entries.length; _i3++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
      key = _Object$entries$_i[0],
      atomOrValue = _Object$entries$_i[1];
    var atomConfig = isAtom(atomOrValue) ? atomOrValue : _atomWithFn(atomOrValue);
    atomsWithoutExtend[key] = atomConfig;
    var writable = "write" in atomConfig;
    atomIsWritable[key] = writable;
    if (writable) {
      writableAtomsWithoutExtend[key] = atomConfig;
    }
  }
  var atoms = __spreadValues({}, atomsWithoutExtend);
  if (extend) {
    var extendedAtoms = extend(atomsWithoutExtend);
    for (var _i4 = 0, _Object$entries2 = Object.entries(extendedAtoms); _i4 < _Object$entries2.length; _i4++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i4], 2),
        _key = _Object$entries2$_i[0],
        _atomConfig = _Object$entries2$_i[1];
      atoms[_key] = _atomConfig;
      atomIsWritable[_key] = "write" in _atomConfig;
    }
  }
  var getAtoms = {};
  var setAtoms = {};
  var useAtoms = {};
  var useStore = function useStore() {
    var optionsOrScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _convertScopeShorthan = convertScopeShorthand(optionsOrScope),
      scope = _convertScopeShorthan.scope,
      store = _convertScopeShorthan.store,
      _convertScopeShorthan2 = _convertScopeShorthan.warnIfNoStore,
      warnIfNoStore = _convertScopeShorthan2 === void 0 ? true : _convertScopeShorthan2;
    var contextStore = _useAtomStore(name, scope, !store && warnIfNoStore);
    return store != null ? store : contextStore;
  };
  var useAtomValueWithStore = function useAtomValueWithStore(atomConfig, optionsOrScope) {
    var _a;
    var options = convertScopeShorthand(optionsOrScope);
    var store = useStore(__spreadValues({
      warnIfNoStore: false
    }, options));
    return (0, import_jotai3.useAtomValue)(atomConfig, {
      store: store,
      delay: (_a = options.delay) != null ? _a : delayRoot
    });
  };
  var useSetAtomWithStore = function useSetAtomWithStore(atomConfig, optionsOrScope) {
    var store = useStore(optionsOrScope);
    return (0, import_jotai3.useSetAtom)(atomConfig, {
      store: store
    });
  };
  var useAtomWithStore = function useAtomWithStore(atomConfig, optionsOrScope) {
    var store = useStore(optionsOrScope);
    var _convertScopeShorthan3 = convertScopeShorthand(optionsOrScope),
      _convertScopeShorthan4 = _convertScopeShorthan3.delay,
      delay = _convertScopeShorthan4 === void 0 ? delayRoot : _convertScopeShorthan4;
    return (0, import_jotai3.useAtom)(atomConfig, {
      store: store,
      delay: delay
    });
  };
  var _loop3 = function _loop3() {
    var key = _Object$keys3[_i5];
    var atomConfig = atoms[key];
    var isWritable = atomIsWritable[key];
    getAtoms[key] = function () {
      var optionsOrScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return useAtomValueWithStore(atomConfig, optionsOrScope);
    };
    if (isWritable) {
      setAtoms[key] = function () {
        var optionsOrScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return useSetAtomWithStore(atomConfig, optionsOrScope);
      };
      useAtoms[key] = function () {
        var optionsOrScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return useAtomWithStore(atomConfig, optionsOrScope);
      };
    }
  };
  for (var _i5 = 0, _Object$keys3 = Object.keys(atoms); _i5 < _Object$keys3.length; _i5++) {
    _loop3();
  }
  var Provider = _createAtomProvider(name, writableAtomsWithoutExtend, {
    effect: effect
  });
  var storeApi = {
    atom: atoms,
    name: name
  };
  var useStoreApi = function useStoreApi() {
    var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      get: __spreadProps(__spreadValues({}, withDefaultOptions(getAtoms, convertScopeShorthand(defaultOptions))), {
        atom: function atom(atomConfig, options) {
          return useAtomValueWithStore(atomConfig, __spreadValues(__spreadValues({}, convertScopeShorthand(defaultOptions)), convertScopeShorthand(options)));
        }
      }),
      set: __spreadProps(__spreadValues({}, withDefaultOptions(setAtoms, convertScopeShorthand(defaultOptions))), {
        atom: function atom(atomConfig, options) {
          return useSetAtomWithStore(atomConfig, __spreadValues(__spreadValues({}, convertScopeShorthand(defaultOptions)), convertScopeShorthand(options)));
        }
      }),
      use: __spreadProps(__spreadValues({}, withDefaultOptions(useAtoms, convertScopeShorthand(defaultOptions))), {
        atom: function atom(atomConfig, options) {
          return useAtomWithStore(atomConfig, __spreadValues(__spreadValues({}, convertScopeShorthand(defaultOptions)), convertScopeShorthand(options)));
        }
      }),
      store: function store(options) {
        return useStore(__spreadValues(__spreadValues({}, convertScopeShorthand(defaultOptions)), convertScopeShorthand(options)));
      }
    };
  };
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, providerIndex, Provider), useStoreIndex, useStoreApi), storeIndex, storeApi), "name", name);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  HydrateAtoms: _HydrateAtoms,
  atomWithFn: _atomWithFn,
  createAtomProvider: _createAtomProvider,
  createAtomStore: _createAtomStore,
  useAtomStore: _useAtomStore,
  useHydrateStore: _useHydrateStore,
  useSyncStore: _useSyncStore
});